import { render } from "./Logs.vue?vue&type=template&id=2b1dc4a1&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"

import "./Logs.vue?vue&type=style&index=0&id=2b1dc4a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1dc4a1"]])

export default __exports__